module.exports = __webpack_public_path__ + "img/Direct.b0e3b12.svg";